import { Component, Inject, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { LoaderService } from 'src/app/services/loader.service';
import { UsersService } from 'src/app/services/users.service';
import { OrderUIState } from 'src/app/interfaces/OrderUIState';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sale-history',
  templateUrl: './sale-history.component.html',
  styleUrls: ['./sale-history.component.scss']
})
export class SaleHistoryComponent implements OnInit {
  defImgProd: string = "assets/logos-nina/nina2_placeholder_cuadrado.jpg";
  userData: any
  ordersHistory: any[] = []
  orderSubscription!: Subscription | undefined;
  userPointsData:any = null

  constructor(public loaderService: LoaderService, public coreService: CoreService, public cookies: CookieService, public apiServices: ApiService, public apiUsersServices: UsersService, public dialog: MatDialog, public router: Router) {

  }

  ngOnInit(): void {
    if (this.cookies.check("UL")) {
      this.getDataProfile()
    }
  }

  startOrderTracking() {
    if (this.orderSubscription) {
      this.orderSubscription.unsubscribe();
    }

    this.orderSubscription = interval(10000).subscribe(() => {
      this.getOrders();
    });
  }

  getDataProfile() {
    this.loaderService.show()
    this.apiUsersServices.me().subscribe({
      next: (value) => {
        if (value.status) {
          this.userData = value.data
          this.getOrders()
          this.startOrderTracking()
          this.getPuntosPorUsuario()
        }
        else {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
        }
        this.loaderService.hide()
      },
      error: (err) => {
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
        console.error(err)
        this.loaderService.hide()
      },
    })
  }

  getPuntosPorUsuario() {
    let data = { token: this.cookies.get('Token'), idCliente: this.userData.id }
    this.apiServices.getPuntosPorUsuario(data).subscribe({
      next: (value) => {
        if (value.length > 0) {
          this.userPointsData = value[0]
          // console.log(this.userPointsData)
          this.loaderService.hide()
        }
        else {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
        }
        this.loaderService.hide()
      },
      error: (err) => {
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
        console.error(err)
        this.loaderService.hide()
      },
    })
  }

  getOrders() {
    let data = {
      idCliente: this.userData.id,
      token: this.cookies.get("Token") ?? ""
    }
    if (data.token == "") {
      this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Tu sesión ha expirado" } });
    }
    else {
      // this.loaderService.show()
      this.apiServices.getHistorialComprasConEstatus(data).subscribe({
        next: async (orders: any[]) => {
          // console.log(orders)
          this.ordersHistory = await Promise.all(
            orders.map(async (order: any) => {
              const uiState = this.mapCarlosStatus(order.estatus);

              if (uiState.showTracking && order.orderIdStandBy) {
                const standby = await this.getStandByStatus(order.orderIdStandBy);
                Object.assign(uiState, this.mapStandByStatus(standby));
              }

              return { ...order, uiState };
            })
          );

          // this.loaderService.hide();
        },

        error: (err) => {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: { text: 'Hubo un error al procesar tu solicitud' }
          });

          console.error(err);
          // this.loaderService.hide();
        },

        complete: () => {
          // this.loaderService.hide();
        }
      });
    }
  }

  getStandByStatus(orderId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.apiUsersServices.getOrderStatus({ orderId }).subscribe({
        next: res => {
          if (res.status) {
            resolve(res.data.computed_status)
          } else {
            reject()
          }
        },
        error: reject
      })
    })
  }

  openDialogTracking(theSale: any): void {
    this.stopOrderTracking();
    const dialogRef = this.dialog.open(DialogTracking, {
      width: '95vw',
      height: '95vh',
      backdropClass: 'nina-dialog-backdrop',
      data: { order: theSale }
    });

    dialogRef.afterClosed().subscribe(result => {
      document.body.classList.remove('mat-mdc-dialog-surface');

      this.getOrders();

      this.startOrderTracking();
    });
  }

  private mapCarlosStatus(status: string): OrderUIState {
    switch (status) {
      case 'CANCELADO':
        return { label: status, color: 'red', showTracking: false }

      case 'APARTADO':
        return { label: status, color: 'blue', showTracking: false }

      case 'VENTA CONFIRMADA':
        return { label: status, color: 'purple', showTracking: false }

      case 'ENTREGADO AL CLIENTE':
        return { label: status, color: 'yellow', showTracking: false }

      case 'ESPERANDO A SER RECOGIDO POR EL CLIENTE':
        return { label: status, color: 'orange', showTracking: false }

      case 'ESPERANDO A SER RECOGIDO POR REPARTIDOR':
      case 'EN REPARTO':
        return { label: 'BUSCANDO REPARTIDOR', color: 'green', showTracking: true }

      default:
        return { label: status, color: 'green', showTracking: false }
    }
  }

  private mapStandByStatus(status: string): Partial<OrderUIState> {
    switch (status) {
      case 'PENDING_OPERATOR':
        return { label: 'BUSCANDO REPARTIDOR', showTracking: false }

      case 'IN_PROGRESS_PICKUP':
        return { label: 'RECOLECTANDO PEDIDO', showTracking: true }

      case 'IN_PROGRESS_DROPOFF':
        return { label: 'PEDIDO EN CAMINO', showTracking: true }

      case 'ON_SITE':
        return { label: 'REPARTIDOR EN EL LUGAR', showTracking: true }

      case 'COMPLETED':
        return { label: 'PEDIDO ENTREGADO', showTracking: false }

      default:
        return {}
    }
  }

  stopOrderTracking() {
    if (this.orderSubscription) {
      this.orderSubscription.unsubscribe()
    }
  }

  ngOnDestroy(): void {
    this.stopOrderTracking()
  }
}

declare var google: any;

@Component({
  selector: 'dialog-tracking',
  templateUrl: 'dialog-tracking.html',
  styleUrls: ['dialog-tracking.scss']
})

export class DialogTracking implements OnInit {
  lat: number = 25.537911020290082;
  lng: number = -103.41543316841125;
  originLatitude: number = 0;
  originLongitude: number = 0;
  destinyLatitude: number = 0;
  destinyLongitude: number = 0;
  dealerLatitude: number = 0;
  dealerLongitude: number = 0;
  isSedan: boolean = false;
  zoom = 13
  order: any = {}
  dataOrderSB: any = {}
  orderSB = ""
  trackingSubscription!: Subscription | undefined;
  prevDealerLatitude = 0;
  prevDealerLongitude = 0;

  direction: 'center' | 'left' | 'right' = 'center';
  dealerIcon = '';
  showDealerMarker = true;
  estimatedTime = '';
  lastStatus = '';

  constructor(private loaderService: LoaderService, private coreService: CoreService, public dialogRef: MatDialogRef<DialogTracking>, @Inject(MAT_DIALOG_DATA) public data: any, public apiServices: ApiService, public usersService: UsersService) {
    this.order = data.order;
    this.orderSB = this.order.orderIdStandBy;
  }

  ngOnInit(): void {
    this.getOrderTracking();
    this.startOrderTracking();
  }

  startOrderTracking() {
    if (this.trackingSubscription) {
      this.trackingSubscription.unsubscribe();
    }

    this.trackingSubscription = interval(5000).subscribe(() => {
      this.getOrderTracking();
    });
  }

  stopOrderTracking() {
    if (this.trackingSubscription) {
      this.trackingSubscription.unsubscribe()
    }
  }

  getOrderTracking() {
    let data = {
      orderId: this.orderSB,
    }
    this.usersService.getOrderStatus(data).subscribe({
      next: (value) => {
        if (value.status) {
          this.originLatitude = value.data.pickup_coord.x
          this.originLongitude = value.data.pickup_coord.y
          this.destinyLatitude = value.data.dropoff_coord.x
          this.destinyLongitude = value.data.dropoff_coord.y
          this.estimatedTime = value.data.eta_mins.realistic
          this.isSedan = value.data.vehicle_type == "SEDAN" ? true : false

          const currentStatus = value.data.computed_status;

          if (currentStatus === 'COMPLETED') {
            this.coreService.emitSubjet.next({
              type: 'Snackbar',
              payload: { text: 'Pedido entregado' }
            });

            this.stopOrderTracking();
            this.dialogRef.close();
            return;
          }

          if (this.lastStatus !== currentStatus) {
            this.lastStatus = currentStatus;

            switch (currentStatus) {
              case 'IN_PROGRESS_PICKUP':
                this.coreService.emitSubjet.next({
                  type: 'Snackbar',
                  payload: { text: 'En proceso de recogida' }
                });
                break;

              case 'IN_PROGRESS_DROPOFF':
                this.coreService.emitSubjet.next({
                  type: 'Snackbar',
                  payload: { text: 'En proceso de entrega' }
                });
                break;

              case 'ON_SITE':
                this.coreService.emitSubjet.next({
                  type: 'Snackbar',
                  payload: { text: 'Repartidor en el lugar' }
                });
                break;
            }
          }

          this.updateDirection(
            value.data.last_coord.latitude,
            value.data.last_coord.longitude
          );

          this.dealerLatitude = value.data.last_coord.latitude;
          this.dealerLongitude = value.data.last_coord.longitude;
        }
        else {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al recuperar la ubicacion" } });
        }
      },
      error: (err) => {
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
        console.error(err)
      },
    })
  }

  updateDirection(newLat: number, newLng: number) {
    if (this.prevDealerLatitude === 0 && this.prevDealerLongitude === 0) {
      this.prevDealerLatitude = newLat;
      this.prevDealerLongitude = newLng;
      return;
    }

    const dLat = newLat - this.prevDealerLatitude;
    const dLng = newLng - this.prevDealerLongitude;

    if (Math.abs(dLat) > Math.abs(dLng)) {
      this.direction = 'center';
    } else {
      this.direction = dLng > 0 ? 'right' : 'left';
    }

    this.prevDealerLatitude = newLat;
    this.prevDealerLongitude = newLng;

    this.updateIcon();
  }

  updateIcon() {
    const vehicle = this.isSedan ? 'car' : 'bike';
    const newIcon = `assets/img/${vehicle}_${this.direction}.png`;

    if (this.dealerIcon !== newIcon) {
      this.showDealerMarker = false;

      setTimeout(() => {
        this.dealerIcon = newIcon;
        this.showDealerMarker = true;
      });
    }
  }

  onNoClick(): void {
    this.stopOrderTracking()
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.stopOrderTracking()
  }
}
